document.addEventListener('DOMContentLoaded', () => {

  // Check if zoom level is over 120% - if so, disable dropdown functionality
  const getZoomLevel = () => {
    return Math.round((window.outerWidth / window.innerWidth) * 100);
  };

  const isZoomTooHigh = () => {
    return getZoomLevel() > 120;
  };

  // Listen for hovers on .submenu-toggle
  const submenuToggles = document.querySelectorAll('.submenu-toggle');

  const hideAllDropdowns = () => {
    submenuToggles.forEach(otherToggle => {
      const otherDropdownMenu = otherToggle.nextElementSibling;
      if (otherDropdownMenu) {
        otherToggle.setAttribute('aria-expanded', 'false');
        otherToggle.classList.remove('show');
        otherDropdownMenu.classList.remove('show');
      }
    });
  };

  submenuToggles.forEach(toggle => {

    const showDropdown = () => {
      // Don't show dropdown if zoom is too high
      if (isZoomTooHigh()) return;

      const dropdownMenu = toggle.nextElementSibling;
      if (dropdownMenu) {
        // Hide all other dropdowns first
        hideAllDropdowns();

        // Then show this dropdown
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('show');
        dropdownMenu.classList.add('show');
      }
    };

    const hideDropdown = () => {
      const dropdownMenu = toggle.nextElementSibling;
      if (dropdownMenu) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('show');
        dropdownMenu.classList.remove('show');
      }
    };

    const isMouseOverDropdownArea = (event) => {
      // Don't do hover detection if zoom is too high
      if (isZoomTooHigh()) return false;

      const dropdownMenu = toggle.nextElementSibling;
      if (!dropdownMenu) return false;

      // Get bounding rectangles
      const toggleRect = toggle.getBoundingClientRect();
      const dropdownRect = dropdownMenu.getBoundingClientRect();

      // Create a combined boundary that includes both toggle and dropdown
      const combinedRect = {
        left: Math.min(toggleRect.left, dropdownRect.left),
        right: Math.max(toggleRect.right, dropdownRect.right),
        top: Math.min(toggleRect.top, dropdownRect.top),
        bottom: Math.max(toggleRect.bottom, dropdownRect.bottom)
      };

      // Check if mouse is within the combined area
      return event.clientX >= combinedRect.left &&
             event.clientX <= combinedRect.right &&
             event.clientY >= combinedRect.top &&
             event.clientY <= combinedRect.bottom;
    };

    const handleMouseLeave = (event) => {
      // Don't handle mouse leave if zoom is too high
      if (isZoomTooHigh()) return;

      // Only hide if mouse is completely outside both toggle and dropdown
      if (!isMouseOverDropdownArea(event)) {
        hideDropdown();
      }
    };

    // Show dropdown on toggle hover (only if zoom is acceptable)
    toggle.addEventListener('mouseenter', showDropdown);

    // Check if mouse left the combined area when leaving toggle
    toggle.addEventListener('mouseleave', handleMouseLeave);

    // Handle dropdown menu hover
    const dropdownMenu = toggle.nextElementSibling;
    if (dropdownMenu) {
      // Keep dropdown open when entering dropdown menu
      dropdownMenu.addEventListener('mouseenter', showDropdown);

      // Check if mouse left the combined area when leaving dropdown
      dropdownMenu.addEventListener('mouseleave', handleMouseLeave);
    }
  });
});
